export default __webpack_public_path__ + "static/media/image.ziphio-private-limited.0f8ebc28.png";